/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { getNewsDetails } from "./newsDetailApiRequest";
import { css } from "@emotion/react";
import { v4 } from "uuid";
import { useRef } from "react";
import DownArrowScroll from "../../../shared/components/reusableComp/DownArrowScroll";
import Markdown from "markdown-to-jsx";
import { useParams } from "react-router-dom";

const bannerWrapper = css`
  width: 100%;
  color: white;
  position: relative;
  img {
    width: 100%;
    vertical-align: bottom;
  }

  .MuiTypography-h5 {
    position: absolute;
    top: 50px;
    left: 80px;
  }
  .MuiTypography-body2 {
    position: absolute;
    top: 90px;
    left: 80px;
    width: 21%;
    height: 74px;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
`;
const cardWrapper = (
  direction,
  isImageRequiredOnRight,
  textMargin,
  titleField
) => css`
  background-color: #121212;

  .MuiBox-root {
    display: flex;
    align-items: center;
    img {
      width: ${direction === "row" ? "50%" : "100%"};
      order: ${direction === "row" && isImageRequiredOnRight === true ? 2 : -1};
    }
    .MuiTypography-h5 {
      text-align: ${textMargin ? "center" : "unset"};
    }
    .MuiTypography-h6 {
      color: white;
      margin: 2% 0;
      font-size: 14px;
      p {
        font-size: 14px;
      }
      span {
        font-size: 14px;
      }
    }
    }
    .MuiCardContent-root {
      padding: 0;
      margin: ${titleField && "20px 0"};
      width: ${direction === "row" ? "50%" : "100%"};
      .MuiTypography-root {
        margin: ${
          direction === "row"
            ? isImageRequiredOnRight
              ? "30px 20px 30px 0px"
              : "30px 0px 30px 20px"
            : textMargin
            ? "10px 15px"
            : "10px 0px"
        };
      }
    }
  }
`;

const newsDetailWrapper = css`
  padding: 0 22%;
  color: white;

  #subTitlePipeId {
    :before {
      content: "|";
      margin: 0px 8px;
    }
  }

  .MuiTypography-h6 {
    color: white;
    padding: 2% 0;
    font-size: 14px;
    p {
      font-size: 14px;
    }
    span {
      font-size: 14px;
    }
  }
  }
  
`;

const mobileTextWrapper = css`
  color: white;
  .MuiTypography-h5 {
    font-size: 1.2rem;
  }

  #subTitlePipeId {
    :before {
      content: "|";
      margin: 0px 8px;
    }
  }

  .MuiTypography-h6 {
    color: white;
    margin: 2% 0 6%;
    p {
      font-size: 14px;
    }
    span {
      font-size: 14px;
    }
  }
`;
const noDataTextStyle = css`
  display: flex;
  height: 38vh;
  justify-content: center;
  align-items: center;
`;
const dividerWrapper = css`
  display: flex;
  justify-content: space-between;
  margin: 40px 0;
  span {
    flex-grow: 2;
    position: relative;
    border-bottom: 1px solid;
    bottom: 14px;
  }
  p {
    margin: 0 20px;
  }
`;
const titleWrapper = (theme) => css`
  font-size: 32px;
  line-height: 32px;
  font-family: ${theme.typography.MBCORPOA};
`;
const typographyH6style = css`
  font-size: 14px;
  line-height: 35px;
  img {
    width: 100%;
  }
`;
const descriptionWrapper = css`
  font-size: 14px;
  line-height: 35px;
`;
const renderCard = (
  imgUrl,
  imgName,
  title,
  description,
  direction,
  isImageRequiredOnRight,
  textMargin
) => {
  return (
    <Card
      css={() =>
        cardWrapper(direction, isImageRequiredOnRight, textMargin, title)
      }
      key={v4()}
    >
      <Box sx={{ display: "flex", flexDirection: direction }}>
        {imgUrl && (
          <CardMedia
            component="img"
            image={`${process.env.REACT_APP_BASEURL}${imgUrl}`}
            alt={imgName}
          />
        )}
        <CardContent>
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            color="text.secondary"
            style={{ width: "140%" }}
          >
            {title}
          </Typography>
          <Typography
            css={descriptionWrapper}
            variant="h6"
            color="text.secondary"
          >
            <Markdown>{description || ""}</Markdown>
          </Typography>
        </CardContent>
      </Box>
    </Card>
  );
};
const DetailItemTitle = ({ title }) => {
  return (
    title && (
      <Typography css={dividerWrapper}>
        <span></span>
        <Typography css={titleWrapper}>{title}</Typography>
        <span></span>
      </Typography>
    )
  );
};
const getMobileView = (
  banner,
  newsDetailImgTextTileData,
  newsDetailCallToAction,
  newsDetailTextTiles
) => {
  return (
    <div>
      {renderCard(
        banner?.data?.attributes?.url,
        banner?.data?.attributes?.name,
        null,
        null,
        // responseData?.title,
        // responseData?.description,
        "column",
        false,
        true
      )}
      <div style={{ padding: "1px 8%" }}>
        <Box css={mobileTextWrapper}>
          <Typography variant="h5" sx={{ display: "inline" }}>
            {newsDetailCallToAction?.title}
          </Typography>
          <Typography
            variant="h5"
            sx={{
              display: newsDetailCallToAction?.subTitle ? "inline" : "none",
            }}
            id="subTitlePipeId"
          >
            {newsDetailCallToAction?.subTitle}
          </Typography>
          <Typography variant="h6" component="div">
            <Typography key={v4()} css={descriptionWrapper}>
              <Markdown>{newsDetailCallToAction?.description || ""}</Markdown>
            </Typography>
          </Typography>
        </Box>
        {newsDetailCallToAction?.image?.data?.attributes?.url && (
          <CardMedia
            component="img"
            image={`${process.env.REACT_APP_BASEURL}${newsDetailCallToAction?.image?.data?.attributes?.url}`}
            alt={`${process.env.REACT_APP_BASEURL}${newsDetailCallToAction?.image?.data?.attributes?.name}`}
            sx={{ margin: "0% 0 6%" }}
          />
        )}
        <DetailItemTitle title={newsDetailTextTiles?.heading} matches={false} />
        <Typography variant="h6" color="text.secondary" css={typographyH6style}>
          <Markdown>
            {(process.env.REACT_APP_BASEURL.includes("localhost")
              ? newsDetailTextTiles?.description?.replaceAll(
                  "/uploads/",
                  `${process.env.REACT_APP_BASEURL}/uploads/`
                )
              : newsDetailTextTiles?.description) || ""}
          </Markdown>
        </Typography>
        {newsDetailImgTextTileData?.map((dataItem) =>
          renderCard(
            dataItem?.image?.data?.attributes?.url,
            dataItem?.image?.data?.attributes?.name,
            dataItem?.title,
            dataItem?.description,
            "column"
          )
        )}
      </div>
    </div>
  );
};
const getDesktopView = (
  banner,
  newsDetailImgTextTileData,
  newsDetailCallToAction,
  newsDetailTextTiles,
  scrollRef
) => {
  return (
    <div>
      {
        <Box css={bannerWrapper}>
          {banner?.data?.attributes?.url && (
            <img
              src={`${process.env.REACT_APP_BASEURL}${banner?.data?.attributes?.url}`}
              alt={`${process.env.REACT_APP_BASEURL}${banner?.data?.attributes?.name}`}
            />
          )}
          <DownArrowScroll scrollRef={scrollRef} />
        </Box>
      }
      <div css={newsDetailWrapper}>
        <Typography variant="h5" sx={{ display: "inline" }}>
          {newsDetailCallToAction?.title}
        </Typography>
        <Typography
          variant="h5"
          sx={{
            display: newsDetailCallToAction?.subTitle ? "inline" : "none",
          }}
          id="subTitlePipeId"
        >
          {newsDetailCallToAction?.subTitle}
        </Typography>
        <Typography css={descriptionWrapper} variant="h6" component="div">
          <Markdown>{newsDetailCallToAction?.description || ""}</Markdown>
        </Typography>

        {newsDetailCallToAction?.image?.data?.attributes?.url && (
          <CardMedia
            component="img"
            image={`${process.env.REACT_APP_BASEURL}${newsDetailCallToAction?.image?.data?.attributes?.url}`}
            alt={`${process.env.REACT_APP_BASEURL}${newsDetailCallToAction?.image?.data?.attributes?.name}`}
            sx={{ padding: "0% 0 6%" }}
            ref={scrollRef}
          />
        )}

        {(newsDetailTextTiles?.heading || newsDetailTextTiles?.description) && (
          <>
            <DetailItemTitle
              title={newsDetailTextTiles?.heading}
              matches={true}
            />
            <Typography
              variant="h6"
              color="text.secondary"
              css={typographyH6style}
            >
              <Markdown>
                {(process.env.REACT_APP_BASEURL.includes("localhost")
                  ? newsDetailTextTiles?.description?.replaceAll(
                      "/uploads/",
                      `${process.env.REACT_APP_BASEURL}/uploads/`
                    )
                  : newsDetailTextTiles?.description) || ""}
              </Markdown>
            </Typography>
          </>
        )}

        {newsDetailImgTextTileData?.map((dataItem) =>
          renderCard(
            dataItem?.image?.data?.attributes?.url,
            dataItem?.image?.data?.attributes?.name,
            dataItem?.title,
            dataItem?.description,
            "row",
            dataItem?.isImageRequiredOnRight
          )
        )}
      </div>
    </div>
  );
};

const NewsDetailPage = ({ Slug }) => {
  const [banner, setBanner] = useState([]);
  const [newsDetailImgTextTileData, setNewsDetailImgTextTileData] = useState(
    []
  );
  const [newsDetailCallToAction, setNewsDetailCallToAction] = useState([]);
  const [newsDetailTextTiles, setNewsDetailTextTiles] = useState([]);
  const [dataFound, setDataFound] = useState(false);

  const isMobile = useMediaQuery("(max-width: 480px)");

  const scrollRef = useRef();
  const { slug } = useParams();

  useEffect(() => {
    slug &&
      getNewsDetails(slug || Slug).then((response) => {
        document.title = response?.data?.data?.attributes?.title;
        const bannerData = response?.data?.data?.attributes?.bannerImage;
        setBanner(bannerData);
        const data = response?.data?.data?.attributes?.body;
        !(bannerData.data || data.length > 0) && setDataFound(true);
        setNewsDetailImgTextTileData(
          data?.filter((i) => i.__component === "components.image-text-tiles")
        );
        setNewsDetailCallToAction(
          data?.filter((i) => i.__component === "components.news-block")[0]
        );
        setNewsDetailTextTiles(
          data?.filter((i) => i.__component === "shared.text-tiles")[0]
        );
      });
  }, [slug]);

  return (
    <div
      style={{
        backgroundColor: "#121212",
        minHeight: isMobile ? "47vh" : "60vh",
      }}
    >
      {dataFound ? (
        <Typography variant="h5" color="text.secondary" css={noDataTextStyle}>
          No Data Found
        </Typography>
      ) : isMobile ? (
        getMobileView(
          banner,
          newsDetailImgTextTileData,
          newsDetailCallToAction,
          newsDetailTextTiles
        )
      ) : (
        getDesktopView(
          banner,
          newsDetailImgTextTileData,
          newsDetailCallToAction,
          newsDetailTextTiles,
          scrollRef
        )
      )}
    </div>
  );
};

export default NewsDetailPage;
